/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_Toggle_LabelInputs */

const en_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request human review of AI decisions`)
};

const de_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menschliche Prüfung von KI-Entscheidungen anfordern`)
};

const fr_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander un examen humain des décisions de l’IA`)
};

const es_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar revisión humana de las decisiones de IA`)
};

const it_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi la revisione umana delle decisioni dell’IA`)
};

const nl_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menselijke beoordeling van AI-beslissingen aanvragen`)
};

const pl_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poproś o weryfikację decyzji AI przez człowieka`)
};

const fi_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pyydä tekoälypäätösten tarkistamista ihmiseltä`)
};

const da_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmod om menneskelig gennemgang af AI-beslutninger`)
};

const sv_candidate_ai_notice_toggle_label = /** @type {(inputs: Candidate_Ai_Notice_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begär mänsklig granskning av AI-beslut`)
};

/**
* | output |
* | --- |
* | "Request human review of AI decisions" |
*
* @param {Candidate_Ai_Notice_Toggle_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_toggle_label = /** @type {((inputs?: Candidate_Ai_Notice_Toggle_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_Toggle_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_toggle_label(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_toggle_label(inputs)
	if (locale === "es") return es_candidate_ai_notice_toggle_label(inputs)
	if (locale === "it") return it_candidate_ai_notice_toggle_label(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_toggle_label(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_toggle_label(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_toggle_label(inputs)
	if (locale === "da") return da_candidate_ai_notice_toggle_label(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_toggle_label(inputs)
	return en_candidate_ai_notice_toggle_label(inputs)
});